import styled from 'styled-components';

export const CourseChooseSkillsStyles = {
  MarginContainer: styled.div`
    margin-bottom: 80px;
  `,
};
